import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ToolTipIcon from '../../../components/ToolTipIcon/ToolTipIcon';
import { getPermissions } from '../../../utils/getPermissions';

function ScheduleActions(props) {
  const { showDuplicateDialog, showFolderSelector, onDelete } = props;
  const { auth, id } = props;
  const p = getPermissions(auth);

  if (!id) {
    return [];
  }

  return (
    <div
      data-test="schedule-actions"
      className="grid grid-cols-[repeat(5,_max-content)] md:grid-cols-[repeat(7,_max-content)] xl:grid-cols-[repeat(14,_max-content)] gap-2 mt-8"
    >
      {p.writer && (
        <ToolTipIcon toolText="Delete Schedule">
          <button
            type="button"
            onClick={onDelete}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/delete_button.svg"
              alt="Delete"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </button>
        </ToolTipIcon>
      )}
      {p.atLeastTierPro && p.writer && (
        <ToolTipIcon toolText="Move Schedule">
          <button
            type="button"
            onClick={showFolderSelector}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/paste_button.svg"
              alt="Delete"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </button>
        </ToolTipIcon>
      )}
      {p.writer && (
        <ToolTipIcon toolText="Duplicate Schedule">
          <button
            type="button"
            onClick={async () => {
              showDuplicateDialog();
            }}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/copy_button.svg"
              alt="Copy"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </button>
        </ToolTipIcon>
      )}
      {/* //TODO: replace with right icon */}
      <ToolTipIcon toolText="Preview Schedule">
        <Link
          to={`/player/?schedule=${id}`}
          target="_blank"
          className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
        >
          <img
            src="/assets/images/icons/play_no_bg.svg"
            alt="Copy"
            className="w-[30px] h-[30px]"
            draggable={false}
          />
        </Link>
      </ToolTipIcon>
    </div>
  );
}

ScheduleActions.propTypes = {
  auth: PropTypes.shape({
    user: PropTypes.shape({
      permissions: PropTypes.shape({
        writer: PropTypes.bool,
      }),
    }),
  }).isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  showFolderSelector: PropTypes.func.isRequired,
  showDuplicateDialog: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
const mapDispatchToProps = {};
const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleActions);
